/**
 * Rug Price Calculator
 * Handles dimension selection, API price calculation, and Add to Cart state
 */

(function() {
  'use strict';

  const PRICES = {
    "Modern Oushak": {
      "Default": {
        "lt_eq_50": 43.75,
        "gt_50": 41.25,
        "w_gt_12": 43.75
      },
      "The Kyoto": {
        "lt_eq_50": 45.00,
        "gt_50": 42.50,
        "w_gt_12": 45.00
      },
      "The Pimlico": {
        "lt_eq_50": 45.00,
        "gt_50": 42.50,
        "w_gt_12": 45.00
      },
      "The Provence": {
        "lt_eq_50": 45.00,
        "gt_50": 42.50,
        "w_gt_12": 45.00
      },
      "The Queenstown": {
        "lt_eq_50": 45.00,
        "gt_50": 42.50,
        "w_gt_12": 45.00
      },
      "The Virginian": {
        "lt_eq_50": 45.00,
        "gt_50": 42.50,
        "w_gt_12": 45.00
      },
      "The Vienna": {
        "lt_eq_50": 45.00,
        "gt_50": 42.50,
        "w_gt_12": 45.00
      },
      "The Birmingham": {
        "lt_eq_50": 47.50,
        "gt_50": 45.00,
        "w_gt_12": 47.50
      },
    },
    "Modern Oushak 6/6": { //??
      "Default": {
        "lt_eq_50": 52.75,
        "gt_50": 50.25,
        "w_gt_12": 52.75
      }
    },
    "flatweave": {
      "Default": {
        "lt_eq_50": 31.00,
        "gt_50": 29.00,
        "w_gt_12": 31.00
      },
      "The Jalisco": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Mykonos": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Nantucket": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Porto": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Santorini": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Tangiers": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Taprobane": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Vienna Flatweave": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      }
    },
    "Jute": {
      "Default": {
        "lt_eq_50": 26.00,
        "gt_50": 24.00,
        "w_gt_12": 26.00
      },
      "The Zanzibar": {
        "lt_eq_50": 29.50,
        "gt_50": 27.00,
        "w_gt_12": 29.50
      },
    },
    "Indoor/Outdoor": {
      "Default": {
        "lt_eq_50": 29.00,
        "gt_50": 27.00,
        "w_gt_12": 29.00
      },
      "The Porto Indoor/Outdoor": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Santorini Indoor/Outdoor": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Tangiers Indoor/Outdoor": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      },
      "The Vienna Indoor/Outdoor": {
        "lt_eq_50": 32.50,
        "gt_50": 30.00,
        "w_gt_12": 32.50
      }
    },
    "New flatweave": { //??
      "Default": {
        "lt_eq_50": 31.00,
        "gt_50": 29.00,
        "w_gt_12": 31.00
      }
    },
    "Rug Pad": {
      "Default": {
        "lt_eq_50": 4.00,
        "gt_50": 3.25,
        "w_gt_12": 4.00
      }
    }
  };

  class RugPriceCalculator {
    constructor(container) {
      this.container = container;
      this.productType = container.dataset.productType;
      this.productTitle = container.dataset.productTitle;

      // Selects
      this.widthFeetSelect = container.querySelector('#rug-width-feet');
      this.widthInchesSelect = container.querySelector('#rug-width-inches');
      this.lengthFeetSelect = container.querySelector('#rug-length-feet');
      this.lengthInchesSelect = container.querySelector('#rug-length-inches');

      // Display elements
      this.loadingElement = container.querySelector('.rug-calculator__loading');
      this.errorElement = container.querySelector('.rug-calculator__error');

      // Hidden inputs for line item properties
      this.customWidthDisplayInput = container.querySelector('#rug-custom-width-display');
      this.customLengthDisplayInput = container.querySelector('#rug-custom-length-display');
      this.customWidthInchesInput = container.querySelector('#rug-custom-width-inches');
      this.customLengthInchesInput = container.querySelector('#rug-custom-length-inches');

      // Rug pad elements
      this.rugPadCheckbox = container.querySelector('#rug-include-pad');
      this.rugPadPriceDisplay = container.querySelector('#rug-pad-price');
      this.rugPadValueInput = container.querySelector('#rug-include-pad-value');

      // Freight elements
      this.freightDisplay = container.querySelector('#rug-freight-display');
      this.freightPriceDisplay = container.querySelector('#rug-freight-price');

      // Find the Add to Cart button and price elements
      this.addToCartButton = this.findAddToCartButton();
      this.productPriceElement = document.querySelector('[data-product-price]');
      this.buttonPriceElement = document.querySelector('[data-button-price]');
      this.buttonPriceSeparator = document.querySelector('[data-button-price-separator]');

      // State
      this.calculatedPrice = null;
      this.rugPadPrice = null;
      this.freightCharge = null;

      this.init();
    }

    init() {
      this.bindEvents();
      this.disableAddToCart();
      this.onDimensionChange();
    }

    bindEvents() {
      const selects = [
        this.widthFeetSelect,
        this.widthInchesSelect,
        this.lengthFeetSelect,
        this.lengthInchesSelect
      ];

      selects.forEach(select => {
        select.addEventListener('change', () => this.onDimensionChange());
      });

      // Rug pad checkbox event (may not exist for Rug Pad products)
      if (this.rugPadCheckbox) {
        this.rugPadCheckbox.addEventListener('change', () => this.onRugPadChange());
      }

      // Watch for variant changes to re-apply calculated price
      this.watchVariantChanges();
    }

    watchVariantChanges() {
      // Watch the hidden variant input for changes
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        // Use MutationObserver to detect when theme JS changes the value attribute
        const observer = new MutationObserver(() => {
          this.onVariantChange();
        });
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

        // Also listen for direct changes
        variantInput.addEventListener('change', () => this.onVariantChange());
      }

      // Some themes use URL changes for variants
      window.addEventListener('popstate', () => this.onVariantChange());
    }

    onVariantChange() {
      // Re-apply our price displays after variant change
      if (this.calculatedPrice !== null) {
        this.updateProductPrice();
        this.updateButtonPrice();
      } else {
        this.setInitialPriceState();
      }
    }

    findAddToCartButton() {
      // Common selectors for Add to Cart buttons across themes
      const selectors = [
        'button[type="submit"][name="add"]',
        'button.add-to-cart',
        'button.btn-add-to-cart',
        'button[data-add-to-cart]',
        '.product-form button[type="submit"]',
        '#AddToCart',
        '.AddToCart'
      ];

      for (const selector of selectors) {
        const button = document.querySelector(selector);
        if (button) return button;
      }

      // Fallback: find the closest form and get its submit button
      const form = this.container.closest('form');
      if (form) {
        return form.querySelector('button[type="submit"]');
      }

      return null;
    }

    updateProductPrice() {
      // Product price shows rug-only price
      if (this.productPriceElement && this.calculatedPrice !== null) {
        this.productPriceElement.textContent = this.formatPrice(this.calculatedPrice);
        this.productPriceElement.style.textTransform = '';
      }
    }

    updateButtonPrice() {
      // Button price shows combined total (rug + pad if checked + freight if applicable)
      if (this.buttonPriceElement) {
        this.buttonPriceElement.textContent = this.formatPrice(this.getTotalPrice());
      }
    }

    getDimensions() {
      return {
        widthFeet: this.widthFeetSelect.value,
        widthInches: this.widthInchesSelect.value,
        lengthFeet: this.lengthFeetSelect.value,
        lengthInches: this.lengthInchesSelect.value
      };
    }

    areDimensionsComplete() {
      const dims = this.getDimensions();
      // Feet and inches are required
      return dims.widthFeet !== '' && dims.widthInches !== '' && dims.lengthFeet !== '' && dims.lengthInches !== '';
    }

    formatDimension(feet, inches) {
      const ft = parseInt(feet, 10);
      const inc = parseInt(inches, 10) || 0;
      
      if (inc === 0) {
        return `${ft}' 0"`;
      }
      return `${ft}' ${inc}"`;
    }

    onDimensionChange() {
      if (this.areDimensionsComplete()) {
        this.calculatePrice();
      } else {
        this.resetState();
      }
    }

    onRugPadChange() {
      if (!this.rugPadCheckbox || !this.rugPadValueInput) return;
      const isChecked = this.rugPadCheckbox.checked;
      this.rugPadValueInput.value = isChecked ? 'Yes' : 'No';
      
      // Update button price when rug pad is toggled (product price stays the same)
      if (this.calculatedPrice !== null) {
        this.updateButtonPrice();
      }
    }

    calculateRugPadPrice(dims) {
      const squareFeet = (parseInt(dims.widthFeet, 10) + parseInt(dims.widthInches, 10) / 12) * 
                         (parseInt(dims.lengthFeet, 10) + parseInt(dims.lengthInches, 10) / 12);
      let pricePerSqFt;

      if (dims.widthFeet > 12 || squareFeet > 180) {
        pricePerSqFt = PRICES['Rug Pad']['Default'].w_gt_12;
      } else if (squareFeet <= 50) {
        pricePerSqFt = PRICES['Rug Pad']['Default'].lt_eq_50;
      } else {
        pricePerSqFt = PRICES['Rug Pad']['Default'].gt_50;
      }

      return squareFeet * pricePerSqFt;
    }

    updateRugPadPriceDisplay() {
      if (!this.rugPadPriceDisplay) return;
      if (this.rugPadPrice !== null) {
        this.rugPadPriceDisplay.textContent = `${this.formatPrice(this.rugPadPrice)}`;
      } else {
        this.rugPadPriceDisplay.textContent = '';
      }
    }

    updateFreightDisplay() {
      if (this.freightCharge !== null && this.freightCharge > 0) {
        this.freightPriceDisplay.textContent = this.formatPrice(this.freightCharge);
        this.freightDisplay.style.display = '';
      } else {
        this.freightDisplay.style.display = 'none';
        this.freightPriceDisplay.textContent = '';
      }
    }

    getTotalPrice() {
      let total = this.calculatedPrice || 0;
      if (this.rugPadCheckbox && this.rugPadCheckbox.checked && this.rugPadPrice !== null) {
        total += this.rugPadPrice;
      }
      if (this.freightCharge !== null) {
        total += this.freightCharge;
      }
      return total;
    }

    async calculatePrice() {

      const dims = this.getDimensions();

      this.disableAddToCart();
      this.hideError();

      try {
        let squareFeet = (parseInt(dims.widthFeet, 10) + parseInt(dims.widthInches, 10) / 12) * (parseInt(dims.lengthFeet, 10) + parseInt(dims.lengthInches, 10) / 12);
        let pricePerSqFt;

        if (dims.widthFeet > 12 || squareFeet > 180) {
          pricePerSqFt = PRICES[this.productType][this.productTitle]?.w_gt_12 || PRICES[this.productType]['Default']?.w_gt_12;
        } else if (squareFeet <= 50) {
          pricePerSqFt = PRICES[this.productType][this.productTitle]?.lt_eq_50 || PRICES[this.productType]['Default']?.lt_eq_50;
        } else {
          pricePerSqFt = PRICES[this.productType][this.productTitle]?.gt_50 || PRICES[this.productType]['Default']?.gt_50;
        }

        if (!pricePerSqFt) {
          throw new Error('Price per square foot not found for product type: ' + this.productType);
        }

        const price = squareFeet * pricePerSqFt;

        this.onPriceCalculated(price, dims, squareFeet);
      } catch (error) {
        console.error('Price calculation error:', error);
        this.showError();
      }
    }

    onPriceCalculated(price, dims, squareFeet) {
      this.calculatedPrice = price;

      // Calculate rug pad price (only if rug pad option exists)
      if (this.rugPadCheckbox) {
        this.rugPadPrice = this.calculateRugPadPrice(dims);
        this.updateRugPadPriceDisplay();
      }

      // Calculate freight charge if applicable
      if (squareFeet > 180 && this.productType !== 'Rug Pad') {
        this.freightCharge = squareFeet * 5;
      } else {
        this.freightCharge = null;
      }
      this.updateFreightDisplay();

      // Format dimensions for display
      const widthFormatted = this.formatDimension(dims.widthFeet, dims.widthInches);
      const lengthFormatted = this.formatDimension(dims.lengthFeet, dims.lengthInches);

      // Update hidden inputs for line item properties
      this.customWidthDisplayInput.value = widthFormatted;
      this.customLengthDisplayInput.value = lengthFormatted;
      this.customWidthInchesInput.value = parseInt(dims.widthInches, 10) + (parseInt(dims.widthFeet, 10) * 12);
      this.customLengthInchesInput.value = parseInt(dims.lengthInches, 10) + (parseInt(dims.lengthFeet, 10) * 12);

      // Update price displays
      this.updateProductPrice();  // Rug-only price
      this.updateButtonPrice();   // Combined price (rug + pad if checked)

      // Enable Add to Cart
      this.enableAddToCart();
    }

    formatPrice(price) {
      // Format price according to Shopify's money format
      // You may need to adjust this based on your store's currency settings
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(price);
    }

    updatePriceDisplay() {
      this.updateProductPrice();
      this.updateButtonPrice();
    }

    showError() {
      this.errorElement.style.display = 'block';
      this.disableAddToCart();
    }

    hideError() {
      this.errorElement.style.display = 'none';
    }
    
    enableAddToCart() {
      if (this.addToCartButton) {
        this.addToCartButton.disabled = false;
        this.addToCartButton.classList.remove('rug-calculator--disabled');
      }
    }

    disableAddToCart() {
      if (this.addToCartButton) {
        this.addToCartButton.disabled = true;
        this.addToCartButton.classList.add('rug-calculator--disabled');
      }
    }

    resetState() {
      this.calculatedPrice = null;
      this.rugPadPrice = null;
      this.freightCharge = null;
      this.hideError();
      this.disableAddToCart();
      
      // Clear hidden inputs
      this.customWidthDisplayInput.value = '';
      this.customLengthDisplayInput.value = '';
      this.customWidthInchesInput.value = '';
      this.customLengthInchesInput.value = '';

      // Clear rug pad price display
      this.rugPadPriceDisplay.textContent = '';

      // Hide freight display
      this.freightDisplay.style.display = 'none';
      this.freightPriceDisplay.textContent = '';

      // Reset price displays to initial state
      this.setInitialPriceState();
    }
  }

  // Initialize when DOM is ready
  function init() {
    const calculators = document.querySelectorAll('.rug-price-calculator');
    calculators.forEach(container => new RugPriceCalculator(container));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
